import { ChevronRightIcon } from '@heroicons/react/20/solid'
import LoginButton from '../components/LoginButton'

export default function LandingPage() {
  return (
    <div className="bg-white">
      <div className="relative isolate overflow-hidden bg-gradient-to-b from-red-100/20">
        <div className="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40">
          <div className="px-6 lg:px-0 lg:pt-4">
            <div className="mx-auto max-w-2xl">
              <div className="max-w-lg">
                <img
                  className="h-16"
                  src="https://res.cloudinary.com/dti7egpsg/image/upload/v1705671150/SIT%20Align/sit_app_logo_dsr3ee.png"
                  alt="SIT HV Lab Logo"
                />
                <div className="mt-24 sm:mt-32 lg:mt-16">
                  <h1 className="font-heading text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    Virtual High Voltage<br className="hidden md:inline " /> Laboratory
                  </h1>
                  <p className="font-sans mt-6 text-lg leading-8 text-gray-600">
                  A web-based platform to enhance teaching and learning​ of topics related to high voltage engineering.
                  </p>
                  <div className="mt-10 flex items-center gap-x-6">
                    <LoginButton />
                    
                    <a href="mailto:support@plexflo.com" className="text-sm font-semibold leading-6 text-gray-900">
                      Email Support <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
            {/* insert an image here */}
            <img
              className="w-full h-full object-cover
                sm:rounded-lg lg:rounded-none"
                src="https://res.cloudinary.com/dti7egpsg/image/upload/v1699327107/SIT%20Align/landingPage_image_ebem1q.png"
                alt="EVIDENCE Landing Page Image"
                />
          </div>
        </div>
        <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
      </div>
    </div>
  )
}
